export const SIGN_UP_REQUEST = "SIGN_UP_REQUEST";
export const SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS";
export const SIGN_UP_ERROR = "SIGN_UP_ERROR";

export const SIGN_OUT = "SIGN_OUT";
export const RESET_AUTH_STATE = "RESET_AUTH_STATE";
export const RESET_STORE_AND_LOG_OUT = "RESET_STORE_AND_LOG_OUT";
